var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "pt-50 pb-50" }, [
    _c("img", {
      attrs: {
        src: "/static/icon-error.svg",
        height: "100px",
        alt: "Temos um problema!"
      }
    }),
    _vm._v(" "),
    _c("h2", [_vm._v("TEMOS UM PROBLEMA!")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Seu pagamento não pode ser processado, por favor tente novamente."
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn bg-pink",
        on: {
          click: function($event) {
            _vm.$emit("clear")
          }
        }
      },
      [_vm._v("Voltar para tentar novamente")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb42ee4c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb42ee4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Error.vue
// module id = null
// module chunks = 